import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal }          from '@ng-bootstrap/ng-bootstrap';
import { TranslateService }        from '@ngx-translate/core';

@Component({
  selector: 'wor-search-email-modal',
  template: `
    <div class="modal-body clearfix">
      <h2 translate="GENERAL_SPACE.MESSAGE.PLEASE_SELECT_AN_EMAIL_ADDRESS"></h2>
      <wor-table
        [(data)]="emails"
        [settings]="tableSettings"
        (rowClick)="onRowClick()">
      </wor-table>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-default pull-left"
        (click)="modal.dismiss()"
        translate="GENERAL_SPACE.BUTTON.CANCEL">
      </button>
      <button *ngIf="emails.length && !allSelected" type="button"
        class="btn pull-left btn-primary"
        (click)="selectAll()"
        translate="GENERAL_SPACE.BUTTON.ALL">
      </button>
      <button *ngIf="allSelected && emails.length" type="button"
        class="btn pull-left btn-warning"
        (click)="selectAll()"
        translate="GENERAL_SPACE.BUTTON.NONE">
      </button>
      <button *ngIf="emails.length" type="button"
        class="btn btn-success"
        [disabled]="!selectedItems.length"
        (click)="modal.close(selectedItems)"
        translate="GENERAL_SPACE.BUTTON.SELECT">
      </button>
    </div>
  `
})
export class SearchEmailModalComponent implements OnInit {
  @Input() emails: any[] = [];

  allSelected    = false;
  selectedItems  : any[] = [];
  tableSettings  : any;

  constructor (
    public modal: NgbActiveModal,
    private translateService: TranslateService
  ) {}

  ngOnInit () {
    this.emails = this.emails.map(email => ({ email }));

    this.tableSettings = {
      columns: [
        {
          field : 'email',
          header: {
            text: this.translateService.instant('GENERAL_SPACE.FIELD.EMAIL_ADDRESS')
          }
        }
      ],
      empty: {
        text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_EMAILS_FOUND')
      },
      pagination: {
        enabled: false
      },
      rows: {
        highlight: {
          enabled: true
        },
        select: {
          enabled: true,
          multi  : true
        }
      },
      sorting: {
        enabled: true
      },
      static: true
    };
  }

  onRowClick () {
    this.selectedItems = this.emails.filter(email => email.selected);
    this.allSelected   = this.selectedItems.length === this.emails.length;
  }

  selectAll () {
    this.allSelected = !this.allSelected;

    this.emails.forEach(email => {
      email.selected = this.allSelected;
    });

    this.selectedItems = this.allSelected ? [...this.emails] : [];
  }
}
